import {Injectable} from '@angular/core';
import {logEvent} from 'firebase/analytics';
import {getAnalyticsInstance} from "./firebase-init";

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  async logEvent(event: string, params?: any): Promise<void> {
    try {
      const analytics = await getAnalyticsInstance();
      if (analytics) {
        logEvent(analytics, event, params);
      }
    } catch (err) {
      console.warn('Analytics logEvent failed:', err);
    }
  }
}
